import { render, staticRenderFns } from "./FormPopup.vue?vue&type=template&id=2bdb1c47"
import script from "./FormPopup.vue?vue&type=script&lang=js"
export * from "./FormPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports